//Imports de components presents dans la page about
import React from "react";
import { useParams } from "react-router-dom";
import Topnav from "../components/Topnav.js";
import Footer from "../components/Footer.js";
import ProjectDetails from "../components/ProjectDetails.js";

//Création du composant
const ProjectDetailsPage = () => {
    // Récupère l'ID depuis l'URL au lieu de props.location.state
    const { id } = useParams();
    
    return (
        <div>
            <Topnav />
            <ProjectDetails id={id} />
            <Footer />
        </div>
    )
}

//Export du composant
export default ProjectDetailsPage;